module.exports = __webpack_public_path__ + "static/media/rc.47294f64.png";